<template>
  <ul class="v-form__list  v-form__list--replicator form__list--full-width">
    <slot :count="count" :data="localData"></slot>
  </ul>
</template>

<script>
import replicator from "../mixins/replicator";

export default {
  mixins: [replicator]
};
</script>



// WEBPACK FOOTER //
// resources/js/admin/components/VFormListReplicator.vue